import { Field, Widget } from '@kanda-libs/ks-component-ts';
import { Text } from '@kanda-libs/ks-design-library';

import { MONTHLY_INCOME_VALIDATION, NOT_EMPLOYED_PROPS } from './constants';

import { ERROR_PROPS } from '../../PrimaryEmployment/constants';
import useEmploymentStatusFields from '../../PrimaryEmployment/useEmploymentStatusFields';
import { MONTHS_OPTIONS } from '../EmploymentMonths/constants';

const RetiredPrimary: React.FunctionComponent = function () {
  const { error, validation, yearsName, monthsName, yearsOptions } =
    useEmploymentStatusFields({
      type: 'primary',
      employmentType: 'retired',
      index: undefined,
      arrayName: undefined,
    });
  return (
    <div className="grid grid-cols-2 gap-x-3 md:gap-x-4">
      <Field.Validator validation={MONTHLY_INCOME_VALIDATION}>
        <Field.NumberInput
          {...NOT_EMPLOYED_PROPS.monthlyIncome}
          className="col-span-2"
        />
      </Field.Validator>
      <span className="col-span-2 text-12-18-em text-neutral-700 w-full mb-2">
        When did you retire?
      </span>
      <Field.Select
        options={MONTHS_OPTIONS}
        name={monthsName}
        placeholder="Month"
      />
      <Field.Select
        options={yearsOptions}
        name={yearsName}
        placeholder="Year"
      />
      {error && <Text text={error} className={ERROR_PROPS.className} />}
      <div className="hidden">
        <Widget.CreditEmploymentDetailsRetiredDetailsMonthsRetired
          validation={validation}
        />
      </div>
    </div>
  );
};

export default RetiredPrimary;
